import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Table } from 'react-bootstrap';
import moment from 'moment';

class ChangeTable extends Component{
	constructor(props){
		super(props);
	}

	componentDidMount(){
		this.props.onRef(this);

		this.props.getList();
	}

	componentWillMount(){
		this.props.onRef(null);
	}

	render(){
		const { t } = this.props;
		return (
			<div className="col-xs-12">
				<Table responsive hover className="llamador">
					<thead>
						<tr>
							<th>{t('content.list_called.table.caller_number')}</th>
							<th>Hora Registro</th>
							<th>{t('content.list_called.table.offer')}</th>
							<th>{t('content.list_called.table.attendant')}</th>
						</tr>
					</thead>
					<tbody>
					{
						this.props.list_called.map((l, i)=>(
							<tr key={i} className={i===0 ? "llamado" : "registrado"}>
								<td>{l.record_number}</td>
								<td>{moment(l.called_timestamp).format('HH:mm')}</td>
								<td>{l.donor}</td>
								<td>
									{l.section}
									{l.machine_name !== null ? ' | '+l.machine_name.split('|')[0] : ''}
								</td>
							</tr>
						))
					}
					</tbody>
				</Table>
			</div>
		);
	}

}

export default translate('translations')(ChangeTable);

